<template>
  <div>
    <div :class="{'has-padding': isShowFooter && !showingTypeAnswerInput}">
      <div v-if="!showingTypeAnswerInput">
        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && $store.state.slide.type != 'pickAnswer'"
        >
          {{ $t("multipleChoiceInstruction") }} {{ $store.state.slide.limitChoice }} {{ $t("options") }}.
        </div>

        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && !this.$store.state.slide.isCorrectGetPoint && $store.state.slide.type == 'pickAnswer'"
        >
          {{ $t("quizYouMustPickAll") }}
        </div>
        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && this.$store.state.slide.isCorrectGetPoint && $store.state.slide.type == 'pickAnswer'"
        >
          {{ $t("mustNotPickIncorrectAnswer") }}
        </div>

        <div
          class="sub-header"
          v-if="!$store.state.slide.multipleChoice && $store.state.slide.type == 'pickAnswer' && checkAnyCorrectAnswer() > 1"
        >
          {{ $t("youCanPickAnyCorrectAnswer") }}
        </div>
      </div>
      <Masonry masonry-id="slide-option-masonry" v-if="viewType === 'image'">
        <MasonryItem :key="slideOption.id" v-for="slideOption in slideOptions">
          <Option
            variant="image"
            :id="slideOption.id"
            :title="slideOption.title"
            :image="slideOption.imageCropped"
            :multiple-select="slide.multipleChoice"
            @handle-image-load="redrawMasonryById('slide-option-masonry')"
            v-model="submittedAnswer"
            :correct="slideOption.correct"
            :disabled="result.id && $store.state.slide.quizStatus == QuizStatuses.QUESTION_SCREEN"
            :show-result="$store.state.slide.quizStatus == QuizStatuses.RESULT_SCREEN"
            :show-number-of-same-answer="optionQuizResult !== null"
            :number-of-same-answer="optionQuizResult && optionQuizResult[slideOption.id]"
            :text-colour="slide.textColour"
            :base-colour="slide.baseColour"
          />
        </MasonryItem>
      </Masonry>

      <template v-if="viewType === 'text'">
        <Option
          :id="slideOption.id"
          v-for="slideOption in slideOptions"
          :base-colour="slide.baseColour"
          :text-colour="slide.textColour"
          variant="text"
          :key="slideOption.id"
          :title="slideOption.title"
          :image="slideOption.imageCropped"
          :multiple-select="slide.multipleChoice"
          v-model="submittedAnswer"
          :correct="slideOption.correct"
          :disabled="result.id && $store.state.slide.quizStatus == QuizStatuses.QUESTION_SCREEN"
          :show-result="$store.state.slide.quizStatus == QuizStatuses.RESULT_SCREEN"
          :show-number-of-same-answer="optionQuizResult !== null"
          :number-of-same-answer="optionQuizResult && optionQuizResult[slideOption.id]"
        />
      </template>

      <div v-if="showingTypeAnswerInput">
        <TypeAnswerQuizInput
          v-if="!isEmptyTypeAnswerAfterTimesUp"
          class="type-answer-input"
          :type="getTypeAnswerDisplayType()"
          :display-user-count="!!optionQuizResult"
          :number-of-user-with-same-answer="optionQuizResult &&
            optionQuizResult[typeAnswerValue.toLowerCase()]"
          v-model="typeAnswerValue"
          @enterKey="submit"
        />

        <div v-if="showingCorrectTypeAnswerInput">
          <p class="type-anwwer-correct-text">
            {{ $t('correctAnswerTitle') }}
          </p>
          <TypeAnswerQuizInput
            v-if="correctTypeAnswer"
            class="type-answer-input"
            type="showCorrectAnswer"
            :value="correctTypeAnswer"
            :display-user-count="!!optionQuizResult"
            :number-of-user-with-same-answer="optionQuizResult &&
              optionQuizResult[correctTypeAnswer.toLowerCase()]"
          />
          <p
            class="type-answer-no-correct-answer"
            v-else
          >
            {{ $t('noCorrectAnswer') }}
          </p>
        </div>
        <div v-if="showingOtherCorrectTypeAnswerInput">
          <p class="type-anwwer-correct-text">
            {{ $t('alsoAccepted') }}
          </p>
          <TypeAnswerQuizInput
            v-for="item in $store.state.slide.otherCorrectQuiz"
            :key="item.id"
            class="type-answer-input type-answer-input--others"
            type="showOtherCorrectAnswer"
            :value="item.title || ''"
            :display-user-count="!!optionQuizResult"
            :number-of-user-with-same-answer="optionQuizResult &&
              optionQuizResult[item.title && item.title.toLowerCase()]"
          />
        </div>
      </div>
    </div>

    <div
      class="quiz-footer animate__animated animate__fadeIn animate__faster"
      :class="{
        show: isShowFooter,
        sticky: !showingTypeAnswerInput,
        animate__animated: !showingTypeAnswerInput,
        animate__fadeIn: !showingTypeAnswerInput,
        animate__faster: !showingTypeAnswerInput,
        'type-answer__footer': showingTypeAnswerInput,
      }"
      :style="{'background-color': showingTypeAnswerInput?null:$store.state.slide.baseColour}"
    >
      <template v-if="$store.state.slide.quizStatus == QuizStatuses.QUESTION_SCREEN">
        <div class="quiz-footer--content">
          <QuizFormSubmitButton
            @submit="submit"
            :disabled="!submittedAnswer && (!typeAnswerValue || typeAnswerValue && !typeAnswerValue.trim())"
            :is-form-submitted="isSubmitted"
          />

          <QuizTimeAnswerText
            v-if="result && result.id && result.timeAnswer"
            :time-left="timeLeft"
            :time-answer="Number(result.timeAnswer)"
            class="animation-text"
          />
        </div>
      </template>

      <template v-if="$store.state.slide.quizStatus == QuizStatuses.RESULT_SCREEN">
        <div class="quiz-footer--content">
          <QuizFormResultButton v-if="result && (result.id || result.notPlay)" :result="result" />
          <QuizSoloResultText
            v-if="!teamPlay&& result && result.id"
            :result="result"
            class="animation-text"
          />
          <QuizTeamResultText
            v-if="teamPlay && teamQuizResult && teamQuizResult.loaded"
            :result-team="teamQuizResult"
            :result-solo="result"
            class="animation-text"
          />
          <QuizNextSlide
            v-if="presentation.audiencePacing && result"
            class="animation-text"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// event bus
import EvenBus from '@/eventBus'

// configs
import Config from '@/config'

// utils
import Util from '@/util'

// storage
import storage from '@/services/storage'

// components
import QuizSoloResultText from '@/components/quiz/QuizSoloResultText.vue'
import QuizTeamResultText from '@/components/quiz/QuizTeamResultText.vue'
import QuizTimeAnswerText from '@/components/quiz/QuizTimeAnswerText.vue'
import QuizStatuses from '@/constants/QuizStatuses'
import TypeAnswerQuizInput from './TypeAnswerQuizInput.vue'
import QuizFormSubmitButton from './QuizFormSubmitButton.vue'
import QuizFormResultButton from './QuizFormResultButton.vue'
import QuizNextSlide from './QuizNextSlide.vue'
import Option from './Option.vue'
import Masonry, { masonryMixin } from '../masonry/Masonry.vue'
import MasonryItem from '../masonry/MasonryItem.vue'

export default {
  components: {
    Option,
    Masonry,
    MasonryItem,
    QuizSoloResultText,
    QuizTeamResultText,
    QuizTimeAnswerText,
    TypeAnswerQuizInput,
    QuizFormSubmitButton,
    QuizFormResultButton,
    QuizNextSlide,
  },
  mixins: [masonryMixin],
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isShowFooter: false,
      timeLeft: 0,
      isSubmitted: false,
      submittedAnswer: null,
      typeAnswerValue: this.result.typeAnswer || '',
      correctTypeAnswer: '',
      optionQuizResult: null,
      teamQuizResult: {},
    }
  },

  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      slide: (state) => state.slide,
      slideOptions: (state) => state.slide.SlideOptions,
      teamPlay: (state) => state.presentation.teamPlay,
      audienceQuizTeam: (state) => state.audienceQuizTeam,
      presentation: (state) => state.presentation,
    }),
    viewType() {
      // TODO: need to refactor for more meaningful name: e.g: quizType()
      if (this.slide.type === 'pickAnswer' && this.slide.slideType === 'imageChoice') {
        return 'image' // Quiz: image choice
      } if (this.slide.type === 'pickAnswer' && this.slide.slideType == null) {
        return 'text' // Quiz: pick answer
      }

      return 'type' // Quiz: type answer
    },

    showingTypeAnswerInput() {
      // TODO: can be removed, because we have quizType() above
      return this.slide.type === 'pickAnswer' && this.slide.slideType === 'typeAnswer'
    },

    showingCorrectTypeAnswerInput() {
      return this.result && !this.result.correct && this.$store.state.slide.quizStatus === 5
    },

    showingOtherCorrectTypeAnswerInput() {
      return this.result
        && this.$store.state.slide.quizStatus === 5
        && this.$store.state.slide.otherCorrectQuiz
        && this.$store.state.slide.otherCorrectQuiz.length
    },

    isEmptyTypeAnswerAfterTimesUp() {
      return this.$store.state.slide.quizStatus === 5 && !this.typeAnswerValue
    },
  },

  watch: {
    '$store.state.slide.quizStatus': function changeStatus(quizStatus) {
      if (quizStatus === 5) {
        this.getQuizResult()
      }
    },
  },

  created() {
    this.QuizStatuses = QuizStatuses
  },

  mounted() {
    setTimeout(() => {
      // Because <QuizForm> is placing inside <transition> component, and the Footer is position-fixed,
      // The footer is flicked when transiting to the question screen.
      // Delay showing the Footer will fix this issue.
      this.isShowFooter = true
    }, 300)
    // get correct type answer
    if (this.$store.state.slide.slideType === 'typeAnswer') {
      if (this.$store.state.slide.correctQuizTypeAnswer) {
        this.correctTypeAnswer = this.$store.state.slide.correctQuizTypeAnswer
      } else if (
        this.$store.state.slide.otherCorrectQuiz &&
        this.$store.state.slide.otherCorrectQuiz.length
      ) {
        this.$store.state.slide.otherCorrectQuiz.forEach((item) => {
          if (item.title && !this.correctTypeAnswer) {
            this.correctTypeAnswer = item.title
          }
        })
      }
    }

    if (this.result && this.result.id) {
      this.submittedAnswer = this.result.vote
    }

    if (this.slide.quizStatus === 5) {
      this.getQuizResult()
    }
  },
  destroyed() {
    this.isShowFooter = false
  },
  methods: {
    getTypeAnswerDisplayType() {
      let type = ''
      if (this.isSubmitted) {
        type = 'disabled'
      }
      if (this.result && this.result.id && this.$store.state.slide.quizStatus === 5) {
        type = this.result.correct ? 'correct' : 'incorrect'
      }
      return type
    },
    async submit() {
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      this.error = ''
      const payload = {
        presentation: this.$store.state.presentation.id,
        slide: this.slide.id,
        audience: this.audienceId,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        slideTimestamp: this.slide.slideTimestamp,
        config: {
          timeToAnswer: this.slide.timeToAnswer,
          quizTimestamp: this.slide.quizTimestamp,
          multipleChoice: this.slide.multipleChoice,
          isCorrectGetPoint: this.slide.isCorrectGetPoint,
          stopSubmission: this.slide.stopSubmission,
          fastAnswerGetMorePoint: this.slide.fastAnswerGetMorePoint,
          otherCorrectQuiz: this.slide.otherCorrectQuiz,
          correctQuizTypeAnswer: this.slide.correctQuizTypeAnswer,
          maxPoint: this.slide.maxPoint,
          minPoint: this.slide.minPoint,
        },
        type: this.slide.type,
        slideType: this.slide.slideType,
      }

      if (this.presentation.audiencePacing) {
        payload.config.audiencePacingTimeAnswer = new Date().getTime() - this.slide.quizTimestamp
      }

      if (this.slide.slideType === 'typeAnswer') {
        payload.config.SlideOptions = []
        payload.typeAnswer = this.typeAnswerValue
        if (!payload.typeAnswer.trim()) {
          return
        }
        payload.vote = []
      } else {
        payload.config.SlideOptions = this.slide.SlideOptions.map((dataOption) => {
          return {
            id: dataOption.id,
            correct: dataOption.correct,
          }
        })
        if (!this.$store.state.slide.multipleChoice) {
          payload.vote = [this.submittedAnswer]
        } else {
          payload.vote = this.submittedAnswer
        }
      }

      payload.audienceName = this.$store.state.audienceName
      payload.audienceEmoji = this.$store.state.audienceEmoji
      EvenBus.$emit('quiz-stop-submit')
      EvenBus.$emit('stop-progess-bar-quiz')

      if (this.$store.state.presentation.teamPlay) {
        payload.audienceTeam = this.$store.state.audienceQuizTeam
      }
      this.isSubmitted = true
      try {
        const res = await this.$http.post(Config.api.createAnswer, payload)
        res.body.timeAnswer = parseFloat(res.body.timeAnswer)
        this.timeLeft = this.$store.state.slide.timeToAnswer - res.body.timeAnswer
        this.timeLeft = parseFloat(this.timeLeft)
        EvenBus.$emit('quiz-waiting-result', {
          timeAnswer: res.body.timeAnswer,
          timeLeft: this.timeLeft,
          answer: res.body,
          notSubmit: true,
        })

        const presentationId = this.$store.state.presentation.id
        const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
        answeredSlideIds.push(this.$store.state.slide.id)
        storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)
        if (this.presentation.audiencePacing) {
          window.setTimeout(() => {
            this.$store.dispatch('updateSlide', {
              quizStatus: 5,
            })
          }, 2e3)
        }
        Util.gaTrackEvent(
          'Audience > Quiz',
          'Submit answer',
          'Audience Submit Answer',
        )
      } catch (error) {
        this.isSubmitted = false
        if (error.body && error.errorCode === 411) {
          this.error = this.$t('submissionClosedButton')
        } else {
          this.error = this.$t('openendedSubmissionFail')
        }
        Util.gaTrackEvent(
          'Multiple Choice Submit',
          'Audience submit fail',
          JSON.stringify(error),
        )
      }
    },
    getQuizResult() {
      if (this.slide.quizResultCache) {
        this.$http.get(this.slide.quizResultCache).then((res) => {
          this.normalizeTeamQuizResult(res.body.teams)
          this.optionQuizResult = this.lowerCaseOptionKey(res.body.options)
        },
        () => {})
      } else {
        this.$http.get(Config.api.slideQuizResult + this.slide.id).then((res) => {
          this.normalizeTeamQuizResult(res.body.teams)
          this.optionQuizResult = this.lowerCaseOptionKey(res.body.options)
        },
        () => {})
      }
    },
    lowerCaseOptionKey(options) {
      return Object.keys(options)
        .filter((k) => !!k)
        .map((k) => ({ [k.toLowerCase()]: options[k] }))
        .reduce((item, agg) => ({ ...item, ...agg }), {})
    },
    normalizeTeamQuizResult(teamQuizResult) {
      if (teamQuizResult) {
        this.teamQuizResult = teamQuizResult
        if (!Object.keys(teamQuizResult).length) {
          this.teamQuizResult.noData = true
        }
      } else {
        this.teamQuizResult.noData = true
      }
      this.teamQuizResult.loaded = true
    },
    checkAnyCorrectAnswer() {
      let count = 0
      if (!this.$store.state.slide.SlideOptions) return count
      this.$store.state.slide.SlideOptions.forEach((item) => {
        if (item.correct) {
          count++
        }
      })
      return count
    },
  },

}
</script>

<style lang="scss" scoped>
.sub-header {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 0 16px 0 16px;
  opacity: 0.7;
}
.type-anwwer-correct-text {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
  text-align: left;
}

.type-answer-no-correct-answer {
  text-align: left;
}

.type-answer-input {
  margin-bottom: 28px;
  &--others {
    margin-bottom: 10px;
  }
}

.quiz-footer {
  display: none;
  width: 100%;
  &.show {
    display: block;
  }
  &.sticky {
    transition: all 0.3s ease;
    box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.04);
    position: fixed;
    bottom: 0;
    left: 0;
    .quiz-footer--content {
      padding: 16px;
    }
  }
  &.type-answer__footer {
    margin-top: 32px;
  }
}

.quiz-footer--content {
  max-width: 710px;
  width: 100%;
  margin: 0 auto;
}

.has-padding {
  padding-bottom: 120px;
}
.animation-text {
  animation: show-height 1s;
  overflow: hidden;
}

@keyframes show-height {
  0% {
    max-height: 0;
  }
  100% {
    max-height: 500px;
  }
}
</style>
